"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _syncEndpoints = _interopRequireDefault(require("../../../actions/stream/syncEndpoints"));
var _actionUtils = require("../../../utils/actionUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function streamToggled(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var attendeeId = _ref2.attendeeId;
  if (!(0, _actionUtils.isSameAttendee)(attendeeId, getState())) {
    dispatch((0, _syncEndpoints["default"])());
  }
}
var _default = exports["default"] = streamToggled;